import * as adminService from './admin.service';
import * as authService from './auth.service';
import * as calculatorsService from './calculators.service';
import * as categoriesService from './categories.service';
import * as companiesService from './companies.service';
import * as customersService from './customers.service';
import * as dashboardService from './dashboard.service';
import * as documentsService from './documents.service';
import * as employeesService from './employees.service';
import * as enumsService from './enums.service';
import * as exportsService from './exports.service';
import * as filesService from './files.service';
import * as GuidelinesService from './guidelines.service';
import * as invoicesService from './invoices.service';
import * as productsService from './products.service';
import * as requestsService from './requests.service';
import * as salariesService from './salaries.service';
import * as sectorsService from './sectors.service';
import * as supportsService from './supports.service';
import * as usersService from './users.service';
import * as historyService from './history.service';
import * as payrollAutomationService from './payroll-automation.service';
import * as agentConfigService from './agent-config.service';
import * as smartParserService from './smart-parser.service';
import * as financialStatementsService from './financial-statements.service';
import * as groupReportingService from './group-reporting.service';
import * as clientReportsService from './client-reports.service';
import * as taxReturnsService from './tax-returns.service';
import * as ledgerCardsService from './ledger-cards.service';
import * as suppliersService from './suppliers.service';
import * as sefStateService from './sef-state.service';
import * as partnerRequestsService from './partner-requests.service';
import * as diReportsService from './di-reports.service';
import * as energyToolsService from './energy-tools.service';
import * as fleetService from './fleet.service';
import * as assistantService from './assistant.service';
import * as aiUsageService from './aiUsage.service';

export const API = {
  admin: adminService,
  auth: authService,
  users: usersService,
  employees: employeesService,
  sectors: sectorsService,
  companies: companiesService,
  dashboard: dashboardService,
  enums: enumsService,
  salaries: salariesService,
  requests: requestsService,
  documents: documentsService,
  files: filesService,
  exports: exportsService,
  calculator: calculatorsService,
  invoices: invoicesService,
  guidelines: GuidelinesService,
  categories: categoriesService,
  customers: customersService,
  products: productsService,
  supports: supportsService,
  history: historyService,
  payrollAutomation: payrollAutomationService,
  agentConfig: agentConfigService,
  smartParser: smartParserService,
  financialStatements: financialStatementsService,
  groupReporting: groupReportingService,
  clientReports: clientReportsService,
  taxReturns: taxReturnsService,
  ledgerCards: ledgerCardsService,
  suppliers: suppliersService,
  sefState: sefStateService,
  partnerRequests: partnerRequestsService,
  diReports: diReportsService,
  energyTools: energyToolsService,
  fleet: fleetService,
  assistant: assistantService,
  aiUsage: aiUsageService,
};
